import { CampaignType } from '@dev/ee-api/ee-api-models';
import { CampaignCreatorType } from '@/services/dictionaries/Paths';

export const getCampaignCreatorType = (campaignType: CampaignType): string => {
    const isABCampaign = campaignType === CampaignType.AbSplit;
    return isABCampaign ? CampaignCreatorType.AB : CampaignCreatorType.REGULAR;
};
